/* unplugin-vue-components disabled */import script from "./index.vue?vue&type=script&setup=true&name=FileList&lang=js"
export * from "./index.vue?vue&type=script&setup=true&name=FileList&lang=js"

import "./index.vue?vue&type=style&index=0&id=5088d4f2&lang=scss"

const __exports__ = script;

export default __exports__